import type { ReactElement } from 'react';

type PayoutSummary = {
  [key: string]: {
    [key: string]: ReactElement;
  };
};

export const PAYOUT_SUMMARIES_PER_STATUS: PayoutSummary = {
  rejected: {
    default: <p>Sorry, we could not process this payout request.</p>,
    requested_by_customer: <></>,
    requested_by_merchant: <></>
  },
  pending: {
    default: <p>The payout request is Pending waiting future execution.</p>
  },
  returned: {
    default: <p>This payout has been returned.</p>
  },
  action_required: {
    default: (
      <div>
        <p className="mb-4">
          An action is needed in order to process this request. Please refer to
          the reason code for more information.
        </p>
      </div>
    )
  }
};
